import React, {useState} from 'react'
import Form from 'react-bootstrap/Form'
import styled from 'styled-components'
export function ColorSelect(props: {
  onChange: (value: string) => void
  label: string
  defaultValue?: string
}) {
  const {onChange, label, defaultValue} = props
  const [value, setValue] = useState(defaultValue || '#000000')
  const handleOnChange = (value: string) => {
    setValue(value)
    onChange(value)
  }
  return (
    <Form.Group className="single__input-field mb-15">
      <label className="input__field-text">{label}</label>
      <ColorInputsHolder>
        <ColorMainInput>
          <Form.Control
            style={{flex: 4, borderRadius: 4}}
            onChange={(e) => {
              handleOnChange(e.target.value)
            }}
            value={value}
          />
        </ColorMainInput>
        <Form.Control
          style={{flex: 1, padding: 0, borderRadius: 4}}
          onChange={(e) => {
            handleOnChange(e.target.value)
          }}
          value={value}
          type="color"
        />
      </ColorInputsHolder>
    </Form.Group>
  )
}
const ColorInputsHolder = styled.div`
  display: flex;
  gap: 15px;
`
const ColorMainInput = styled.div`
  position: relative;
  & > .close {
    position: absolute;
    right: 6px;
    top: 6px;
    color: black;
    cursor: pointer;
    font-width: bold;
  }
`
